import React, { useState } from 'react';
import {
  Box,
  Paper,
  Tabs,
  Tab,
  Typography,
  Chip
} from '@mui/material';
import {
  Chat,
  TrendingUp,
  Campaign,
  LocalOffer,
  Assignment,
  SmartToy
} from '@mui/icons-material';
import WhatsAppChat from './WhatsAppChat';
import LeadsManagement from './LeadsManagement';
import CampaignManagement from './CampaignManagement';
import OffersManagement from './OffersManagement';
import FormsManagement from './Forms';

const CRMDashboard = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <WhatsAppChat />;
      case 1:
        return <LeadsManagement />;
      case 2:
        return <CampaignManagement />;
      case 3:
        return <OffersManagement />;
      case 4:
        return <FormsManagement />;
      default:
        return null;
    }
  };

  return (
    <Box sx={{ bgcolor: '#f0f2f5', minHeight: 'calc(100vh - 80px)' }}>
      {/* Header */}
      <Box sx={{ p: 3, bgcolor: '#fff', borderBottom: '1px solid #e9edef' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography variant="h4" fontWeight="700" color="#111b21">
              CRM & Customer Engagement
            </Typography>
            <Typography variant="subtitle1" color="#667781">
              kooppAi-Style Chat, Leads, Campaigns & AI Insights
            </Typography>
          </Box>
          <Chip icon={<SmartToy />} label="AI Powered" color="primary" variant="outlined" />
        </Box>
      </Box>

      {/* Navigation Tabs */}
      <Paper sx={{ borderRadius: 0 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          sx={{
            '& .MuiTab-root': {
              minHeight: 64,
              textTransform: 'none',
              fontSize: '0.95rem',
              fontWeight: 500
            }
          }}
        >
          <Tab icon={<Chat />} label="Chat" iconPosition="start" />
          <Tab icon={<TrendingUp />} label="Leads" iconPosition="start" />
          <Tab icon={<Campaign />} label="Campaigns" iconPosition="start" />
          <Tab icon={<LocalOffer />} label="Offers" iconPosition="start" />
          <Tab icon={<Assignment />} label="Forms" iconPosition="start" />
        </Tabs>
      </Paper>

      {/* Tab Content */}
      {renderTabContent()}
    </Box>
  );
};

export default CRMDashboard;
